// extracted by mini-css-extract-plugin
module.exports = {"mapPlaceholder":"ClaimWitness_mapPlaceholder__mrOOe","label":"ClaimWitness_label__3K_Bc","pinIcon":"ClaimWitness_pinIcon__2cDUi"};